import { EDeliveryRestriction } from 'models/product'

export const YANDEX_PROHIBITED_GOODS_URL =
  'https://yandex.ru/support/delivery-profile/ru/other-day/prohibited-for-delivery'

// Цитаты из правил Яндекс Доставки. Пункты 5Post приходят через API Яндекса,
// поэтому ограничение закрывает и их
export const DELIVERY_RESTRICTIONS: Record<
  EDeliveryRestriction,
  { label: string; section: string; quote: string }
> = {
  [EDeliveryRestriction.FOOD]: {
    label: 'Корма и пищевые продукты',
    section:
      'Предметы, которые требуют специального оборудования для транспортировки',
    quote: 'Любые пищевые продукты и напитки, а также корма для животных…'
  },
  [EDeliveryRestriction.MEDICINE]: {
    label: 'Ветпрепараты и БАД',
    section: 'Медицинские товары',
    quote:
      'Биологически активные добавки, лекарственные травы, а также препараты: которые выписываются по рецептам и не находятся в свободном обороте; срок годности которых на момент отправки составляет менее трех месяцев; которые требуют особых условий хранения.'
  },
  [EDeliveryRestriction.TOXIC]: {
    label: 'Средства от насекомых и ядовитые вещества',
    section: 'Токсичные и инфекционные вещества',
    quote:
      'Ядовитые вещества и биологически опасные материалы. Исключения: средства для защиты растений и средства против насекомых с маркировкой Л или ЛС в каталоге Минсельхоза.'
  }
}

export const DELIVERY_RESTRICTION_OPTIONS = Object.values(
  EDeliveryRestriction
).map((value) => ({ value, label: DELIVERY_RESTRICTIONS[value].label }))
